import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { Box, HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import { Select } from "@ui/select/Select";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";
import { ITheme } from "@ui/theme/GlobalTheme";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { IClient } from "src/services/ClientService";
import { IAcquirerChannel, IFeeEntry } from "src/types/types";
import { useTheme } from "styled-components";

export const S_FEE_COMPARE_POPUP = new Signal<{} | null>("S_FEE_COMPARE_POPUP");

const getMerchantsRequest = (client_id: number, showDeleted: boolean) => {
	return {
		method: "merchants/list",
		data: {
			client_id: client_id,
			status: showDeleted ? "deleted" : undefined,
		},
	};
};

export const FeeComparePopup = () => {
	useLocale();
	const theme = useTheme() as ITheme;

	const requestData = S_FEE_COMPARE_POPUP.use();

	const requestClients = {
		//acquirerId: acquirerId, channelId: channelId, terminalId: terminalId
	};

	const [reqClients, _reloadClients, _, _busy] = GD.REQ_CLIENTS.useRequest(undefined, requestClients);

	// const [groupReq, _1, _2, busy] = GD.REQ_GROUP.useRequest(undefined, {
	// 	groupID: parseInt(router.currentParams.mid ?? 0),
	// 	clientID: clientId,
	// });

	const [clients, setClients] = useState<IClient[]>();
	const [merchants, setMerchants] = useState<IClientGroup[]>();
	const [channels, setChannels] = useState<IAcquirerChannel[]>();
	const [fees, setFees] = useState<any[]>();
	const [channelFees, setChannelFees] = useState<IFeeEntry[]>();

	const [selectedClient, setSelectedClient] = useState<IClient>();
	const [selectedMerchant, setSelctedMerchant] = useState<IClientGroup>();
	const [selectedChannel, setSelctedChannel] = useState<IAcquirerChannel>();

	useEffect(() => {
		if (reqClients?.data) {
			setClients(reqClients.data);
		} else {
			//!TODO:;
		}
	}, [reqClients]);

	useEffect(() => {
		setChannels(undefined);
		setSelctedChannel(undefined);
		setFees(undefined);
		if (selectedMerchant) {
			loadChannels(selectedMerchant.id);
		}
	}, [selectedMerchant]);

	useEffect(() => {
		setMerchants(undefined);
		setChannels(undefined);
		setSelctedMerchant(undefined);
		setSelctedChannel(undefined);
		setFees(undefined);
		if (selectedClient) {
			loadMerchants(selectedClient.id);
		}
	}, [selectedClient]);

	useEffect(() => {
		setFees(undefined);

		if (selectedChannel) {
			loadFees(selectedChannel);
		}
	}, [selectedChannel]);

	const loadMerchants = async (clientId: number) => {
		const merchantsReq2 = await GD.REQ_API.request({
			method: "data/get",
			data: { target_type: "merchant" },
		});
		if (merchantsReq2.data) {
			//setMerchants(merchantsReq.data);
		} else {
			//!TODO:;
		}

		const merchantsReq = await GD.REQ_API.request(getMerchantsRequest(clientId, false));
		if (merchantsReq.data) {
			setMerchants(merchantsReq.data);
		} else {
			//!TODO:;
		}
	};

	const loadChannels = async (merchantId: number) => {
		const channelsReq = await GD.REQ_MERCHANT_ATTACHED_CHANNELS.request({ merchantID: merchantId });
		if (channelsReq.data) {
			setChannels(channelsReq.data);
		} else {
			//!TODO:;
		}
	};

	const loadFees = async (channel: IAcquirerChannel) => {
		const feesChannelReq = await GD.REQ_API.request({
			method: "settings/get",
			data: {
				target_id: channel.id,
				target_type: "channel",
				type: "fees",
			},
		});
		if (feesChannelReq.data && feesChannelReq.data.data && feesChannelReq.data.data.currency && Array.isArray(feesChannelReq.data.data.currency)) {
			setChannelFees(feesChannelReq.data.data.currency);
		} else {
			//!TODO:;
		}

		const feesReq = await GD.REQ_API.request({
			method: "settings/get",
			data: {
				target_id: channel.link_id,
				target_type: "merchant_terminal",
				type: "fees",
			},
		});
		if (feesReq.data && feesReq.data.data && Array.isArray(feesReq.data.data)) {
			setFees(feesReq.data.data);
		} else {
			//!TODO:;
			setFees([]);
		}
	};

	if (!requestData) return null;

	const closePopup = () => {
		setSelectedClient(undefined);
		setSelctedMerchant(undefined);
		S_FEE_COMPARE_POPUP.invoke(null);
	};

	return (
		<Panel
			sx={{
				minWidth: "800px",
				// width: "85vw",
				height: "85vh",
				padding: "0",

				// minWidth: "500px",
			}}
			decorator="absolute"
			label={msg("feeCompare")}
			onClose={closePopup}>
			<HBox gap="20px" sx={{ flex: 1 }}>
				<VBox gap="12px" sx={{ width: "270px", alignContent: "start" }}>
					<Box>
						<Select
							size="small"
							label={msg("client")}
							sheetAlign="left"
							onChange={e => {
								setSelectedClient(e);
							}}
							value={selectedClient}
							values={clients}
						/>
					</Box>
					<Box>
						<Select
							size="small"
							label={msg("merchant")}
							sheetAlign="left"
							onChange={e => {
								setSelctedMerchant(e);
							}}
							value={selectedMerchant}
							values={merchants}
						/>
					</Box>
					<Box>
						<Select
							size="small"
							label={msg("channel")}
							sheetAlign="left"
							onChange={e => {
								setSelctedChannel(e);
							}}
							value={selectedChannel}
							values={channels}
						/>
					</Box>
				</VBox>

				<VBox gap="12px" sx={{ flex: 1 }}>
					{channelFees && fees && (
						<VBox>
							<VBox sx={{ backgroundColor: theme.colors.backgroundPrimary, padding: "10px", borderRadius: "8px" }}>
								{/* <Typo variant="small">Channel Fees:</Typo> */}
								{channelFees.map((fee: IFeeEntry) =>
									fee.rates.map(r => (
										<VBox gap="10px">
											<HBox gap="5px">
												<Typo
													variant="text"
													sx={{ backgroundColor: "#4c6688", color: "#fff", padding: "4px 8px", borderRadius: "4px" }}>
													{fee.currency}
												</Typo>
												<Typo
													variant="text"
													sx={{ backgroundColor: "#4c6688", color: "#fff", padding: "4px 8px", borderRadius: "4px" }}>
													{r.type}
												</Typo>
											</HBox>

											<HBox gap="8px">
												<VBox gap="4px" sx={{ width: "50%" }}>
													<Typo variant="small">{msg("acquirerFee")}</Typo>
													<VBox
														sx={{
															flex: 1,
															backgroundColor: theme.colors.panelBackgroundPrimary,
															padding: "10px", 
															borderRadius: "8px",
														}}>
														<HBox gap="4px" sx={{ justifyContent: "space-between" }}>
															<Typo variant="text">{msg("percentageFee")}</Typo>
															<Typo variant="text">{r.fee}%</Typo>
														</HBox>
														<HBox gap="4px" sx={{ justifyContent: "space-between" }}>
															<Typo variant="text">{msg("fixedFee_9f3618db")}</Typo>
															<Typo variant="text">{r.fee_fixed}</Typo>
														</HBox>
													</VBox>
												</VBox>

												<VBox gap="4px" sx={{ width: "50%" }}>
													<Typo variant="small">{msg("merchantFee")}</Typo>
													<VBox sx={{ flex: 1, backgroundColor: theme.colors.fail, padding: "10px", borderRadius: "8px" }}>
														<Typo variant="text" color="#fff">{msg("notSet")}</Typo>
													</VBox>
												</VBox>
											</HBox>
										</VBox>
									))
								)}
							</VBox>

							{/* <VBox>
								<Typo variant="small">Merchant Fees:</Typo>
								{fees.map(f => (
									<Typo variant="text">{f}</Typo>
								))}
							</VBox> */}
						</VBox>
					)}
				</VBox>
			</HBox>

			<Spacer size="20px" />

			<VBox sx={{ gap: "12px", width: "100%", alignSelf: "end" }}>
				<HBox gap="12px" sx={{ width: "100%" }}>
					<Button
						sx={{ flex: 1 }}
						title={msg("close")}
						onClick={() => {
							closePopup();
						}}
					/>
				</HBox>
			</VBox>
		</Panel>
	);
};
